exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".savedops--header--R6PH1pZf {\r\n  margin-top: 0;\r\n  font-weight: 300;\r\n  padding-left: 8px;\r\n  color: #0072CE;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.savedops--noSavedOps--f6fEPu-g {\r\n  padding-left: 16px;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/views/savedOps/savedops.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;CACrB;;AAED;EACE,mBAAmB;CACpB","file":"savedops.css","sourcesContent":[".header {\r\n  margin-top: 0;\r\n  font-weight: 300;\r\n  padding-left: 8px;\r\n  color: #0072CE;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.noSavedOps {\r\n  padding-left: 16px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"header": "savedops--header--R6PH1pZf",
	"noSavedOps": "savedops--noSavedOps--f6fEPu-g"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/views/savedOps/savedops.css
// module id = 446
// module chunks = 0